import { mapState } from 'vuex';
import { Section, Center, Row } from '@styled/global';
import styled from 'vue-styled-components';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   transition: all 0.4s ease;\n   font-family: ", ";\n   font-style: normal;\n   font-weight: 300;\n   line-height: inherit;\n   padding: 0;\n   cursor: default;\n   color: #fff;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var H1 = styled("h1", {})(_templateObject(), function (props) {
  return props.theme.fontFamily;
}); // export const H1 = styled("h1", {
//    fontSize: { default: () => [2, 2, 3, 4, 5], type: [String, Object, Array] },
//    lineHeight: {
//       default: () => [1, 1, 2, 4, 6],
//       type: [String, Object, Array]
//    },
//    margin: {
//       default: () => [
//          "2px 0 4px 8px",
//          "2px 0 4px 8px",
//          "2px 0 6px 10px",
//          "2px 0 6px 12px",
//          "2px 0 8px 14px"
//       ],
//       type: [Number, String, Object, Array]
//    }
// })`
//    ${fontSize}
// 	${space}
// 	${margin}
// 	transition: all .4s ease;
//    font-family: ${props => props.theme.fontFamily};
//    font-style: normal;
//    font-weight: 300;
//    line-height: inherit;
//    padding: 0;
//    cursor: default;
//    color: #fff;
//    -webkit-font-smoothing: antialiased;
// `;

var script = {
  props: {},
  computed: _extends({}, mapState("page", ["page"]), {}, mapState("theme", ["theme"]), {}, mapState("viewport", ["breakpoint", "scroll"])),
  render: function render() {
    var h = arguments[0];
    var _this$theme = this.theme,
        primaryColor = _this$theme.primaryColor,
        fontSizes = _this$theme.fontSizes;
    var isMobile = this.breakpoint === "xs" || this.breakpoint === "sm";
    var isScrolled = this.scroll.y > 4;
    var title = this.page.h1 ? this.page.h1 : "Unknown";
    var fontSizeLookup = {
      xs: fontSizes[3],
      sm: fontSizes[3],
      md: fontSizes[4],
      lg: fontSizes[5],
      xl: fontSizes[5]
    };
    var targetHeightLookup = {
      xs: 20 + "px",
      sm: 20 + "px",
      md: 30 + "px",
      lg: 40 + "px",
      xl: 40 + "px"
    };
    var fontSize = isMobile || isScrolled ? fontSizeLookup["sm"] : fontSizeLookup[this.breakpoint];
    var height = isMobile || isScrolled ? targetHeightLookup["sm"] : targetHeightLookup[this.breakpoint];
    var style = {
      fontSize: fontSize,
      marginLeft: "16px"
    };
    var sectionStyle = {
      transition: "height 0.4s ease",
      boxShadow: "0 3px 5px rgba(0, 0, 0, .55)"
    };
    return h(Section, {
      "style": sectionStyle,
      "attrs": {
        "background": primaryColor
      }
    }, [h(Center, {
      "attrs": {
        "flexDirection": "row",
        "justifyContent": "left"
      }
    }, [h(Row, [h(H1, {
      "style": style
    }, [title, " (", this.breakpoint, ")"])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
